<template>
  <div>
    <table class="w-full whitespace-no-wrap">
      <tr class="text-left font-bold">
        <!-- Your table headers here -->
      </tr>
      <template v-for="(wallets, currency) in displayedGroups">
        <tr v-for="wallet in wallets" :key="wallet.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <!-- Your table row content here -->
        </tr>
      </template>
    </table>

    <!-- Pagination controls -->
    <div class="mt-6 -mb-1 flex flex-wrap pagenav">
      <template v-for="(link, key) in paginationLinks">
        <div
          :key="key"
          class="mr-1 mb-1 px-4 py-3 text-sm border rounded text-gray-400 bg-white"
          :class="{ 'ml-auto': link.label === 'Next' }"
          v-html="link.label"
        ></div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    groupedData: Object, // Pass the grouped data to the component
    currentPage: Number,
    groupsPerPage: Number,
    changePage: Function,
  },
  computed: {
    displayedGroups() {
      const start = (this.currentPage - 1) * this.groupsPerPage;
      const end = start + this.groupsPerPage;
      const groups = Object.values(this.groupedData);
      return groups.slice(start, end);
    },
    paginationLinks() {
      const totalPages = Math.ceil(Object.values(this.groupedData).length / this.groupsPerPage);
      const links = [];

      // Implement your pagination links logic here
      // You can generate the links based on the current page, total pages, etc.

      return links;
    },
  },
};
</script>
